import { Pressable, View } from 'react-native';
import { Text } from '@/components/ui/text';
import { Icon } from '~/global/components/icon/Icon';
import { MealType } from '@fytness/shared';
import { useTranslation } from 'react-i18next';
import type { IconProps } from '~/global/components/icon/Icon';
import { useColor } from '~/global/hooks/useColor';

const MEAL_TYPE_ORDER: MealType[] = [
  MealType.BREAKFAST,
  MealType.LUNCH,
  MealType.SNACK,
  MealType.DINNER,
];

const MEAL_TYPE_ICONS: Record<MealType, IconProps['name']> = {
  BREAKFAST: 'Sunrise',
  LUNCH: 'Sun',
  SNACK: 'Apple',
  DINNER: 'Moon',
};

export interface MealTypeSelectorProps {
  selected: MealType;
  onSelect: (type: MealType) => void;
}

export const MealTypeSelector = ({
  selected,
  onSelect,
}: MealTypeSelectorProps) => {
  const { t } = useTranslation('meal');
  const accentColor = useColor('accent');
  const mutedColor = useColor('text-muted');

  return (
    <View className="flex flex-row gap-2">
      {MEAL_TYPE_ORDER.map((type) => {
        const isActive = selected === type;
        return (
          <Pressable
            key={type}
            testID={`meal-type-${type.toLowerCase()}`}
            onPress={() => onSelect(type)}
            className={`flex-1 flex items-center justify-center gap-1 rounded-xl h-14 ${
              isActive
                ? 'bg-accent-soft border-2 border-accent'
                : 'bg-surface-elevated border-2 border-transparent'
            }`}
          >
            <Icon
              name={MEAL_TYPE_ICONS[type]}
              size={20}
              color={isActive ? accentColor : mutedColor}
            />
            <Text
              className={`text-[10px] ${
                isActive
                  ? 'font-inter-semibold text-accent'
                  : 'font-inter-medium text-text-muted'
              }`}
            >
              {t(`mealType.${type.toLowerCase()}`)}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
};
